import { AirUrlParams } from 'hooks/useAirNavigation';
import * as Range from 'types/_general/Search/Range';

export type Type = {
	left: number | null;
	right: number | null;
};

export function create(): Type {
	return {
		left: null,
		right: null,
	};
}

export function getMaxRoundUp(max: number): number {
	return Math.ceil(max);
}

export function getMinRoundDown(min: number): number {
	return Math.floor(min);
}

export function mapToApi(obj: Type): Range.Type {
	return {
		maximum: obj.right,
		minimum: obj.left,
	};
}

export function getFromUrl(params: AirUrlParams, urlKey: string): Type {
	const result = create();
	for (const [key, value] of Object.entries(params)) {
		switch (key) {
			case `${urlKey}Left`:
				result.left = Number(value);
				break;
			case `${urlKey}Right`:
				result.right = Number(value);
				break;
		}
	}
	return result;
}
